import React from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';

import { TradeInTotals } from './TradeInTotals';
import { DealBuilderFormValues } from '../../../../types';

interface Props {
  form: UseFormReturn<DealBuilderFormValues>;
  onAddRow: () => void;
}

export const TradeInListingActionPanelBottom = ({ form, onAddRow }: Props) => (
  <Box
    sx={{
      display: 'flex',
      gap: '1rem',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
  >
    <Button variant="outlined" size="small" startIcon={<AddIcon fontSize="small" />} onClick={onAddRow}>
      Add More
    </Button>

    <TradeInTotals form={form} />
  </Box>
);
